import { graphql } from "gatsby"
import React from "react"
import {
  Base, Flex, Text
} from "./ui"
import * as styles from "./ui.css"
import ReactHtmlParser from 'react-html-parser'
import { GatsbyImage, getImage } from "gatsby-plugin-image"

export default function Stats(props) {
  return (
    <Base as="div" cx={[styles.statsSection]}>
      <Flex cx={[styles.herosectionFlex]} gap={0}>
        <Base as="div" cx={[styles.herosectionTextBoxOuter]}>
          <Base as="div" cx={[styles.statssectionTextBox]}>
            <Text variant={'kickerHowItWorks'}>
              {props.kicker}
            </Text>
            <Text variant="statbody">
              {ReactHtmlParser(props.heading)}
            </Text>
          </Base>
        </Base>
        <Base as="div" cx={[styles.statsImageBox]}>
          <Base as="div" cx={[styles.statsFullOuter]}>
            <Base as="div" cx={[styles.imageCompleteStats]}>
              <Base as="div" cx={[styles.backgroundStats]} style={{ textAlign: 'center' }}>
                <Text variant={'kickerHowItWorks2'}>
                  {props.text}
                </Text>
                {
                  props.content.map((item) => {
                    return (
                      <Base as="div" cx={[styles.statItem]}>
                        <Text variant={'statItemValue'}>{item.value}</Text>
                        <Text variant={'statItemLabel'}>{item.label}</Text>
                      </Base>
                    )
                  })
                }
              </Base>
              <Base
                as={GatsbyImage}
                placeholder='none'
                alt={props.image.alt}
                image={getImage(props.image.gatsbyImageData)}
                className={[styles.imageStats]}
              />
              <Base
                as={GatsbyImage}
                placeholder='none'
                alt={props.icon.alt}
                image={getImage(props.icon.gatsbyImageData)}
                className={[styles.iconStats]}
              />
            </Base>
          </Base>
          <Flex cx={[styles.statsBackgroundFlex]} gap={0}>
            <Base as='div' cx={[styles.rightBottomBackContainerFitness]} />
            <Base as='div' cx={[styles.rightBottomBackContainerMind]} />
            <Base as='div' cx={[styles.rightBottomBackContainerMedical]} />
            <Base as='div' cx={[styles.rightBottomBackContainerFinancial]} />
          </Flex>
        </Base>
      </Flex >
    </Base >
  )
}

export const query = graphql`
  fragment HomepageStatListContent on HomepageStatList {
    id
    kicker
    heading
    text
    image {
      id
      gatsbyImageData
      alt
    }
    icon {
      id
      gatsbyImageData
      alt
    }
    content {
      id
      value
      label
    }
  }
`
